import { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card } from "@mui/material";
import {
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Table,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { formRender, initialValues, pickFaceLocationValidations } from "./pickface-location-schema";
import PickFaceLocationInfo from "./components/PickFaceLocationInfo";
import { createPickFaceLocation } from "services/data.internal.service";
import Layout from "layouts/views/components/Layout";
import { useCustomerValue } from "providers/CustomerContext";
import { Success,Error } from "ui-components/Alert";
import { InboundLayout } from "ui-components/Layout";
import { Error_ } from "ui-components/Alert";
import { useNavigate } from "react-router-dom";
function NewPickFaceLocation() {
  const { customerCode: customerValue } = useCustomerValue();
  const customerCode = customerValue;
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [locationsId, setLocationsId] = useState([]);
  const [selectedSKU, setSelectedSKUs] = useState([]);
  // const [selectedCells, setSelectedCells] = useState([]);
  // const [routingDirection, setRoutingDirection] = useState("no-direction");
  // const [routingData, setRoutingData] = useState([]);
  const [skuOptions, setSkuOptions] = useState([]);
  const [prefLoc, setPrefLoc] = useState([]);

  const defaultValues = {
    ...initialValues,
    levelSetting: "Customer-level"
  }

  const form = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(pickFaceLocationValidations),
  });
  const {
    register,
    control,
    formState: { errors },
    setValue,
    getValues,
    watch,
    handleSubmit,
    reset,
    trigger,
  } = form;
  const pFProps = {
    formRender,
    control,
    errors,
    watch,
    setValue,
    customerCode,
    locationsId,
    setLocationsId,
    // selectedCells,
    // setSelectedCells,
    skuOptions,
    setSkuOptions,
    selectedSKU,
    setSelectedSKUs,
    prefLoc,
    setPrefLoc,
    setAlert,
  };

  const createPickFaceLocationMutation = useMutation(createPickFaceLocation, {
    onSuccess: (data) => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Success data={data} onChange={setAlert}/>);
    },
    onError: (data) => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error data={data} onChange={setAlert} />);
    },
  });

  const onSubmit = async () => {
    const isValid = await trigger();
    if (!isValid) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      return;
    }
    const values = getValues();

    if (!values.locationID || values.locationID.length === 0) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={"Invalid Location IDs"} onChange={setAlert} />);
      return;
    }
    if (values.levelSetting !== "All customer, vendor and SKU" && (!Boolean(selectedSKU) || selectedSKU.length === 0)) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={"Invalid selections"} onChange={setAlert} />);
      return;
    }

    const selected = selectedSKU.map(x => {
      const [customerCodeStr, vendorCodeStr, skuCodeStr] = x.split('_');
      const customerCode = customerCodeStr !== "null" && customerCodeStr !== "undefined" ? customerCodeStr : null;
      const vendorCode = vendorCodeStr !== "null" && vendorCodeStr !== "undefined" ? vendorCodeStr : null;
      const skuCode = skuCodeStr !== "null" && skuCodeStr !== "undefined" ? skuCodeStr : null;
      const result = {customerCode: customerCode, vendorCode: vendorCode, skuCode: skuCode};
      return result;
    })
    if (selected.some(x => (x.vendorCode === null || x.vendorCode === "") && 
    selected.some(y => y.customerCode===x.customerCode && y.vendorCode !== null && y.vendorCode !== ""))){
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error content={"Error inserting SKUs, existed setting for all vendors"} onChange={setAlert} />);
      return;
    }
    
    const filtered = skuOptions.filter(x => selectedSKU.some(y => y === x.id));

    if (filtered.some(x => (x.qtyToReplenish !== null && x.uomType === null) || (x.qtyToReplenish === null && x.uomType !== null) )){
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setAlert(<Error_ content={"Invalid Selection, Quantity To Replenish Must Select UOM Type"} onChange={setAlert} />);
      return;
    }

    const {selection, ...val} = values;

    const req = {
      ...val,
      selection: filtered,
      pickFaceLocationDetails: values.locationID.map(x => {
        return {locationId: x, routeSequence: 0};
      }),
    };

    createPickFaceLocationMutation.mutate(
      {
        ...req,
      },
      {
        onSuccess: (data) => navigate("/setup/pickface-location", { state: data.data.message }),
        onError: (data) => setAlert(<Error_ data={data} onChange={setAlert} />),
      }
    );
  };
  const createStatus = createPickFaceLocationMutation.status === "loading";

  return (
    <InboundLayout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Card sx={{ height: "100%" }}>
          <MDBox p={3}>
            <PickFaceLocationInfo {...pFProps} />
            {/* {selectedCells.length !== 0 && (
              <RoutingForm
                locationsId={locationsId}
                selectedLocationsId={locationID}
                routingData={routingData}
                setRoutingData={setRoutingData}
                routingDirection={routingDirection}
                setRoutingDirection={setRoutingDirection}
                selectedCells={selectedCells}
              />
            )} */}
          </MDBox>
          <MDBox p={3}>
            <SubmitButton label="Submit" disabled={createStatus} url="/setup/pickface-location" />
          </MDBox>
        </Card>
      </form>
    </InboundLayout>
  );
}

// function RoutingForm({
//   locationsId,
//   selectedLocationsId,
//   routingData,
//   setRoutingData,
//   routingDirection,
//   setRoutingDirection,
//   selectedCells,
// }) {
//   const selectedRows = selectedCells.map((cell) => cell.rowIndex);
//   const selectedColumns = selectedCells.map((cell) => cell.columnIndex);
//   const minRowIndex = Math.min(...selectedRows);
//   const maxRowIndex = Math.max(...selectedRows);
//   const minColumnIndex = Math.min(...selectedColumns);
//   const maxColumnIndex = Math.max(...selectedColumns);

//   useEffect(() => {
//     assignRouting();
//   }, [selectedLocationsId, routingDirection]);

//   const isCellSelected = (rowIndex, columnIndex) => {
//     return selectedCells.some(
//       (cell) => cell.rowIndex === rowIndex && cell.columnIndex === columnIndex
//     );
//   };
//   const subTable = [];

//   for (let rowIndex = minRowIndex; rowIndex <= maxRowIndex; rowIndex++) {
//     const rowData = [];
//     for (let columnIndex = minColumnIndex; columnIndex <= maxColumnIndex; columnIndex++) {
//       const cellData = selectedCells.find(
//         (cell) => cell.rowIndex === rowIndex && cell.columnIndex === columnIndex
//       );
//       if (cellData) {
//         rowData.push(locationsId[cellData.rowIndex][cellData.columnIndex]);
//       } else {
//         rowData.push("");
//       }
//     }
//     subTable.push(rowData);
//   }

//   const assignRouting = () => {
//     if (selectedLocationsId.length > 0) {
//       let routingValue;
//       let routes = [];
//       if (routingDirection == "no-direction" || routingDirection == null) {
//         routingValue = Array(selectedLocationsId?.length).fill(0);
//         selectedLocationsId.forEach((x, index) =>
//           routes.push({ locationId: x, routeSequence: routingValue[index] })
//         );
//       } else {
//         routingValue = Array(selectedLocationsId?.length).fill(1);
//         routingValue = routingValue.map((r, index) => r * (index + 1));
//         var routeIndex = 0;
//         switch (routingDirection) {
//           case "right-down":
//           case "left-down":
//             for (var row = 0; row < subTable.length; row++) {
//               if (routingDirection == "right-down") {
//                 for (var col = 0; col < subTable[0].length; col++) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               } else {
//                 for (var col = subTable[0].length; col >= 0; col--) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               }
//             }
//             break;
//           case "left-up":
//           case "right-up":
//             for (var row = subTable.length - 1; row >= 0; row--) {
//               if (routingDirection == "right-up") {
//                 for (var col = 0; col < subTable[0].length; col++) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               } else {
//                 for (var col = subTable[0].length; col >= 0; col--) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               }
//             }
//             break;
//           case "down-right":
//           case "up-right":
//             for (let col = 0; col < subTable[0].length; col++) {
//               if (routingDirection == "down-right") {
//                 for (let row = 0; row < subTable.length; row++) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               } else {
//                 for (var row = subTable.length - 1; row >= 0; row--) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               }
//             }
//             break;
//           case "down-left":
//           case "up-left":
//             for (var col = subTable[0].length; col >= 0; col--) {
//               if (routingDirection == "down-left") {
//                 for (let row = 0; row < subTable.length; row++) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               } else {
//                 for (var row = subTable.length - 1; row >= 0; row--) {
//                   if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
//                     routes.push({
//                       locationId: locationsId[minRowIndex + row][minColumnIndex + col],
//                       routeSequence: routingValue[routeIndex++],
//                     });
//                   }
//                 }
//               }
//             }
//             break;
//           default:
//             break;
//         }
//       }
//       setRoutingData(routes);
//     }
//   };

//   const [routingSubTable, setRoutingSubTable] = useState([]);

//   useEffect(() => {
//     let table = subTable.map((row, rowIndex) =>
//       row.map((cellData, columnIndex) => {
//         if (isCellSelected(minRowIndex + rowIndex, minColumnIndex + columnIndex)) {
//           let data = routingData.filter((r) => r.locationId == cellData);
//           if (data[0]) return data[0];
//         }
//         return cellData;
//       })
//     );
//     for (var row = 0; row < table.length; row++) {
//       if (table[row].every((cell) => cell == "")) {
//         table.splice(row, 1);
//         row--;
//       }
//     }
//     for (var col = 0; col < table[0].length; col++) {
//       if (table.every((row) => row[col] == "")) {
//         table.forEach((row) => row.splice(col, 1));
//         col--;
//       }
//     }
//     setRoutingSubTable(table);
//   }, [routingData]);

//   return (
//     <>
//       <MDBox>
//         <MDBox pt={1} pb={2}>
//           <MDTypography color="info" variant="h5">
//             Route Sequence
//           </MDTypography>
//         </MDBox>
//         <Table style={{ borderCollapse: "collapse", marginBottom: "10px" }}>
//           <TableBody>
//             {routingSubTable.map((row, rowIndex) => (
//               <TableRow key={rowIndex}>
//                 {row.map((cellData, columnIndex) => (
//                   <TableCell
//                     key={`${rowIndex}-${columnIndex}`}
//                     style={{
//                       backgroundColor: cellData != "" ? "Gainsboro" : "transparent",
//                       border: "1px solid black",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {cellData != "" ? (
//                       <>
//                         {`${cellData.locationId}`}{" "}
//                         <span style={{ color: "red", fontWeight: "bold" }}>
//                           ({`${cellData.routeSequence}`})
//                         </span>
//                       </>
//                     ) : (
//                       <>{cellData}</>
//                     )}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </MDBox>
//       <MDBox>
//         <FormControl style={{ width: "100%" }}>
//           <MDBox pt={1} pb={2}>
//             <MDTypography color="info" variant="h5">
//               Routing Direction
//             </MDTypography>
//           </MDBox>
//           <RadioGroup
//             row
//             value={routingDirection}
//             onChange={(e) => setRoutingDirection(e.target.value)}
//           >
//             <Grid container>
//               <Grid item xs={12} sm={6}>
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="no-direction"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>No Direction</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="right-down"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Right Down</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="left-down"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Left Down</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="right-up"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Right Up</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="left-up"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Left Up</span>}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="down-right"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Down Right</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="up-right"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Up Right</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="down-left"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Down Left</span>}
//                 />
//                 <FormControlLabel
//                   style={{ marginLeft: "0px" }}
//                   value="up-left"
//                   control={<Radio />}
//                   label={<span style={{fontSize: "1rem", fontWeight:"300", lineHeight:"1.6", color:"black"}}>Up Left</span>}
//                 />
//               </Grid>
//             </Grid>
//           </RadioGroup>
//         </FormControl>
//       </MDBox>
//     </>
//   );
// }

export default NewPickFaceLocation